import { supabase } from '@/lib/supabase';
import { Profile, Project, Row } from '@/shared/types/api';

type Props = {
  orgId: number;
};

export type OrgMemberWithProfile = Row<'org_members'> & {
  profile: Profile;
};

export type OrgMemberWithProfileAndProjectAccess = OrgMemberWithProfile & {
  project_members?: {
    project: Project;
  }[];
};

export const getOrgMembers = async ({ orgId }: Props) => {
  const { data, error } = await supabase
    .from('org_members')
    .select(
      '*, profile:profiles!inner(*), project_members(*, project:projects!inner(*))',
    )
    .eq('org_id', orgId);

  if (error) {
    throw error;
  }
  return data;
};
